@if (attachment(); as attachment) {
    <tran-base-file-item
        [fileName]="attachment.name"
        [isDeleted]="isDeleted()"
        [downloadEnabled]="allowDownload()"
        [deleteEnabled]="allowDelete()"
        [undoDeleteEnabled]="allowUndoDelete()"
        (download)="download.emit(attachment)"
        (delete)="onDeleteFile()"
        (undoDelete)="undoDeleteFile()"
    />
}

<tran-file-delete-modal #deleteFileModal (fileDeleted)="onDeleteFileModalClosed($event)" />
